// extracted by mini-css-extract-plugin
module.exports = {"login":"_3omZ_","logOutText":"_1UDJF"};